import { FrontPriceSection } from '@spa/services/api/purchase'

import _ from 'lodash'

export default class CalculateBundleDiscount {
  constructor(
    private estimatedPriceSections: FrontPriceSection[]
  ) {}

  public apply(): number {
    return _.sumBy(this.estimatedPriceSections, priceSection =>
      priceSection.discount ? priceSection.discount.bundle.amount : 0
    )
  }
}
